import { createReducer, createActions } from "reduxsauce";
import Immutable from "seamless-immutable";
import { HISTORIC, RECSYS, CHATBOT, SIMILARITY } from "../../constants";

/* Types & Action Creators */

export const { Types, Creators } = createActions({
  cityRequest: [],
  getCities: ["filter"],
  citySuccess: ["context", "data"],
  cityError: ["err"],
});

/* Initial State */

export const INITIAL_STATE = Immutable({
  data: [],
  [HISTORIC]: [],
  [RECSYS]: [],
  [SIMILARITY]: [],
  [CHATBOT]: [],
  loading: false,
  error: false,
});

/* Reducers */

export const request = (state) => state.merge({ loading: true });

export const success = (state, { context, data }) =>
  state.merge({ [context]: data, error: false, loading: false });

export const error = (state) => state.merge({ loading: false, error: true });

/* Reducers to types */

export default createReducer(INITIAL_STATE, {
  [Types.CITY_REQUEST]: request,
  [Types.CITY_SUCCESS]: success,
  [Types.CITY_ERROR]: error,
});
